import React, { useState, useEffect, useReducer } from "react";
import Navbar from "../../../../components/Navbar";
import SideBar from "../../../../components/SideBar";
import { GetServiceCaller, PostServiceCaller } from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import { FaSpinner, FaPlus, FaMinus, FaPlusCircle, FaMinusCircle } from 'react-icons/fa';
import { useNavigate, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";



const organizeData = (data) => {
    // Ensure `data` is an array, or default to an empty array
    const validData = Array.isArray(data) ? data : [];

    const organized = validData.reduce((acc, item) => {
        // Treat `Module` and `SubModule` as blank strings if null or undefined
        const Module = item.Module ?? '';
        const SubModule = item.SubModule ?? '';
        const { ObjectType, ObjectTypeIdentifier, DisplayName } = item;

        if (!acc[Module]) {
            acc[Module] = { submodules: {} };
        }

        if (!acc[Module].submodules[SubModule]) {
            acc[Module].submodules[SubModule] = {
                displayName: SubModule,
                identifiers: []
            };
        }

        acc[Module].submodules[SubModule].identifiers.push({
            ObjectType,
            ObjectTypeIdentifier,
            DisplayName
        });

        return acc;
    }, {});

    return organized;
};


const EditRole = () => {
    const { role_id } = useParams();
    const [loading, setLoading] = useState(true);
    const [formData, setFormData] = useState({
        RoleName: '',
        Description: '',
        active: 1,
        permissions: []
    });
    const [errors, setError] = useState({});
    const [state, dispatch] = useReducer(reducer, { permissions: [] });

    const [expandedModules, setExpandedModules] = useState({});
    const [expandedSubmodules, setExpandedSubmodules] = useState({});
    const [organizedData, setOrganizedData] = useState({});
    console.log("organizedData", organizedData);
  const dispatchs = useDispatch();

  useEffect(() => {
    dispatchs(updateNavbarHeading("Roles"));
  }, [])
    const [submitted, setSubmit] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchRolesPermissionAndModule = async () => {
            try {
                const response = await GetServiceCaller(`${API_URL}role/${role_id}`);
                const permissions_opt = response.data.roles;
                console.log(permissions_opt);
                // console.log(``);
                console.log("permission raw from API", permissions_opt);
                dispatch({ type: "FETCH_PERMISSIONS", payload: permissions_opt });
                setFormData({
                    ...formData,
                    'RoleName': response.data.role.Name,
                    'Description': response.data.role.Description,
                    'active': response.data.role.Active,
                    ...response.data.permission
                })
                setLoading(false);

            } catch (error) {
                console.error("Error fetching roles:", error);
            }
        };
        fetchRolesPermissionAndModule();
    }, []);
    useEffect(() => {
        setOrganizedData(organizeData(state?.permissions));
    }, [state?.permissions]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value })
    }

    const handleRadio = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value })
    }
    const handleChange = (e) => {
        const { name, checked } = e.target;
        const [action, identifier] = name.split(':');

        setFormData(prev => {
            const updatedPermissions = checked
                ? [...new Set([...(prev[identifier] || []), action])]
                : (prev[identifier] || []).filter(a => a !== action);

            const updatedData = {
                ...prev,
                [identifier]: updatedPermissions
            };

            return updatedData;
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // Add form submission logic here
        console.log(formData);
        if (formData.RoleName == '') {
            setError({ ...errors, RoleName: { status: true, message: "This field is required." } })
        } else {
            setSubmit(true)
            let response = await PostServiceCaller(API_URL + 'role/' + role_id, formData, 'put');
            if (response.data.status == 'success') {
                setSubmit(false);
                toast.success(response.data.msg);
                navigate('/roles');
            } else {
                setSubmit(false);
                toast.error(response.data.msg);
            }
        }
    };

    const handleExpandModule = (e, module) => {
        e.preventDefault();
        setExpandedModules(prev => ({ ...prev, [module]: !prev[module] }));
    };

    const handleExpandSubmodule = (e, submodule) => {
        e.preventDefault();
        setExpandedSubmodules(prev => ({ ...prev, [submodule]: !prev[submodule] }));
    };

    const handleSelectAll = (identifier, isChecked) => {
        setFormData(prev => {
            const updatedData = { ...prev };
            const allActions = ['view', 'create', 'edit', 'delete', 'print', 'export', 'import'];

            updatedData[identifier] = isChecked ? allActions : [];

            return updatedData;
        });
    };

    if (loading) {
        return (
            <p className="position-absolute top-50 start-50 translate-middle text-center">
                <FaSpinner className="spinner" />
            </p>
        );
    }

    return (
        <>
            <div className="Container">
                <form onSubmit={handleSubmit} id="formOne" className="rounded mt-2 bg-white">
                    <div className="container-fluid">
                        <div className="row p-2">
                            <div className="col-sm-3">
                                <div className="form-group">
                                    <label className="form-label">Name <span className="required">*</span></label>
                                    <input
                                        type="text"
                                        name="RoleName"
                                        className="form-control"
                                        placeholder="Role Name"
                                        onChange={handleInputChange}
                                        value={formData.RoleName}
                                    />
                                    {errors?.RoleName?.status && <span className="error">{errors?.RoleName?.message}</span>}
                                </div>
                            </div>
                            <div className="col-sm-4">
                                <div className="form-group">
                                    <label className="form-label">Description</label>
                                    <input
                                        type="text"
                                        name="Description"
                                        className="form-control"
                                        placeholder="Description"
                                        onChange={handleInputChange}
                                        value={formData.Description}
                                    />
                                    {errors?.Description && <span className="error">{errors.Description}</span>}
                                </div>
                            </div>
                            <div className="col-sm-2 mt-4">
                                <div className="d-flex gap-2 justify-content-start">
                                    <label htmlFor="IsInActive" className="form-label">Active</label>
                                    <div className="me-2 mt-0">
                                        <div className="d-flex">
                                            <div className="form-check me-2">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="active"
                                                    value={1}
                                                    checked={formData.active == 1}
                                                    onChange={handleRadio}
                                                />
                                                <label className="form-check-label">Yes</label>
                                            </div>
                                            <div className="form-check me-2">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="active"
                                                    value={0}
                                                    checked={formData.active == 0}
                                                    onChange={handleRadio}
                                                />
                                                <label className="form-check-label">No</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                <label className="form-label m-0">Permissions</label>
                                <hr className="my-2"/>
                                <table className="table table-bordered">
                                    <thead className="sticky-header">
                                        <tr>
                                            <th>Process</th>
                                            <th>Identifier</th>
                                            <th>Select All</th> {/* New column for Select All */}
                                            <th>View</th>
                                            <th>Create</th>
                                            <th>Edit</th>
                                            <th>Delete</th>
                                            <th>Print</th>
                                            <th>Export</th>
                                            <th>Import</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Object.keys(organizedData).map(module => (
                                            <React.Fragment key={module}>
                                                <tr>
                                                    <td colSpan="10" className="fw-bold">
                                                        <button
                                                            className="btn btn-icon"
                                                            onClick={(e) => handleExpandModule(e, module)}
                                                        >
                                                            {expandedModules[module] ? <FaMinusCircle /> : <FaPlusCircle />}
                                                        </button>
                                                        <span className="module-name">Module : {module ? module : ''}</span>
                                                    </td>
                                                </tr>
                                                {expandedModules[module] && (
                                                    <>
                                                        {Object.keys(organizedData[module].submodules).map(submodule => (
                                                            <React.Fragment key={submodule}>
                                                                <tr>
                                                                    <td colSpan="10" className="fw-bold indent">

                                                                        <span className="submodule-name"><button
                                                                            className="btn btn-icon"
                                                                            onClick={(e) => handleExpandSubmodule(e, submodule)}
                                                                        >
                                                                            {expandedSubmodules[submodule] ? <FaMinusCircle /> : <FaPlusCircle />}
                                                                        </button>
                                                                            Sub Module: {submodule}</span>
                                                                    </td>
                                                                </tr>
                                                                {expandedSubmodules[submodule] && (
                                                                    <>
                                                                        {organizedData[module].submodules[submodule].identifiers.map(identifier => (
                                                                            <tr key={identifier.ObjectType}>

                                                                                <td className="identifier">{identifier.DisplayName}</td>
                                                                                <td>{identifier.ObjectTypeIdentifier}</td>
                                                                                <td className="text-center">
                                                                                    <input
                                                                                        className="form-check-input"
                                                                                        type="checkbox"
                                                                                        checked={['view', 'create', 'edit', 'delete', 'print', 'export', 'import'].every(action => formData[identifier.ObjectType]?.includes(action))}
                                                                                        onChange={(e) => handleSelectAll(identifier.ObjectType, e.target.checked)}
                                                                                    />
                                                                                </td>
                                                                                {['view', "create", 'edit', 'delete', 'print', 'export', 'import'].map(action => (
                                                                                    <td className="text-center" key={action}>
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            name={`${action}:${identifier.ObjectType}`}
                                                                                            checked={formData[identifier.ObjectType]?.includes(action)}
                                                                                            onChange={handleChange}
                                                                                            className="form-check-input"
                                                                                        />
                                                                                    </td>
                                                                                ))}

                                                                            </tr>
                                                                        ))}
                                                                    </>
                                                                )}
                                                            </React.Fragment>
                                                        ))}
                                                    </>
                                                )}
                                            </React.Fragment>
                                        ))}
                                    </tbody >
                                </table>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="col-md-12  mt-2">
                                    <div className="d-flex justify-content-end">
                                        <div className="d-flex">
                                            <div>
                                                <button type="button" className="cancel-btn me-2" onClick={() => navigate(`/roles`)}>Cancel</button>
                                            </div>
                                            <div>
                                                <button
                                                    disabled={submitted ? true : false}
                                                    type="submit"
                                                    className="custom-btn"
                                                >
                                                    {submitted ? (
                                                        <FaSpinner class="sm-spinner" />
                                                    ) : (
                                                        "Submit"
                                                    )}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>

        </>
    );
};

const reducer = (state, action) => {
    switch (action.type) {
        case 'FETCH_PERMISSIONS':
            return {
                ...state,
                permissions: action.payload
            };
        default:
            return state;
    }
};

export default EditRole;
